<template>
  <transition name="fade" mode="out-in">
    <div
      v-show="open"
      class="_popup"
      :style="{
        width: width ? width + 'px' : '',
        position: isFixed ? 'fixed' : 'absolute',
        top: position.top + 'px',
        left: position.left + 'px',
        bottom: position.bottom + 'px',
        right: position.right + 'px',
        zIndex,
        border,
        borderColor,
        borderRadius: borderRadius + 'px',
      }"
    >
      <div v-if="needModal" class="_popup_modal" @click="$emit('modal')" />
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Popup",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object,
      default: () => ({ top: 45, left: 0 }),
    },
    zIndex: {
      type: Number,
      default: 1,
    },
    width: {
      type: Number,
    },
    border: {
      type: String,
      default: "1px #df6250 solid",
    },
    borderColor: {
      type: String,
      default: "#df6250",
    },
    borderRadius: {
      type: Number,
      default: 10,
    },
    needModal: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/config.scss";

._popup {
  min-width: 50px;
  min-height: 80px;
  width: fit-content;
  height: fit-content;
  background-color: white;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);

  ._popup_modal {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1;
  }
}
</style>
